import { render } from "./ModalActualClient.vue?vue&type=template&id=7bf9952c&scoped=true"
import script from "./ModalActualClient.vue?vue&type=script&lang=js"
export * from "./ModalActualClient.vue?vue&type=script&lang=js"

import "./ModalActualClient.vue?vue&type=style&index=0&id=7bf9952c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf9952c"]])

export default __exports__